import { render } from "./DashShortcuts.vue?vue&type=template&id=12a3c9f9&scoped=true&ts=true"
import script from "./DashShortcuts.vue?vue&type=script&lang=ts"
export * from "./DashShortcuts.vue?vue&type=script&lang=ts"

import "./DashShortcuts.vue?vue&type=style&index=0&id=12a3c9f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a3c9f9"]])

export default __exports__